// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-progress{color:#6d7278;font-size:14px}.ui-progress__line{overflow:hidden;position:relative;height:4px;background:#9e9e9e}.ui-progress_rounded .ui-progress__line{border-radius:8px}.ui-progress__now{position:absolute;top:0;bottom:0;left:0;border-radius:inherit;transition:width .2s ease-in-out}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
